import React, { useEffect, useState } from "react";
import { apiRequest } from "../utils/api";
import { useAlert } from '../components/AlertModal';
import EmailComposeModal from "./EmailComposeModal";
import "../styles/MailDetail.css";

const extractFromBody = (text) => {
  const nameMatch = text.match(/【お名前】(.+?)\r?\n/);
  const namefoidMatch = text.match(/\[ お名前 \](.+?)\r?\n/);
  const dateMatch = text.match(/集荷ご希望日[:：]\s*(\d{4}年\d{1,2}月\d{1,2}日(?:\[[^\]]+\])?)/);
  const timeMatch = text.match(/(09:00.*|12:00.*|15:00.*|18:00.*|指定しない)/);
  const shippingMatch = /商品の発送方法：自分で発送/.test(text)
    ? "self"
    : /商品の発送方法：集荷希望/.test(text)
    ? "pickup"
    : "unknown";
  const typeMatch = /TYPE-A/.test(text) ? "A" : /TYPE-B/.test(text) ? "B" : "unknown";

  const itemRegex = /【商品番号】(.+?)【商品名\d+】(.+?)\[個数\](\d+)/g;
  const matches = [];
  let match;
  while ((match = itemRegex.exec(text)) !== null) {
    matches.push({
      productNumber: match[1].trim(),
      productName: match[2].trim(),
      quantity: match[3].trim(),
    });
  }
  
  return {
    name: nameMatch?.[1]?.trim() ?? "未記載",
    name_forid: namefoidMatch?.[1]?.trim() ?? "未記載",
    date: dateMatch?.[1] ?? "未記載",
    timeslot: timeMatch?.[1] ?? "未記載",
    shippingMethod: shippingMatch,
    buyType: typeMatch,
    items:matches,
  };
};



const emailFooter = `━━━━━━━━━━━━━━━━━━━━━━━━
ぱそまる
〒 556-0005　大阪府大阪市浪速区日本橋4-15-14
E-mail：https://www.pasomaru.co.jp/cgiform/searchbuy/form.cgi
━━━━━━━━━━━━━━━━━━━━━━━━
`;

const emailTemplates = {
  buy_request: {
    subject: "【ご確認ください】買取申込ありがとうございます～ぱそまる～",
    body: ({ name, date, timeslot, shippingMethod, buyType, items}) => {
      const shippingText =
        shippingMethod === "self"
          ? `━━━━━━━━━━━━━━━━━━━━━━━━\n「自分で発送」となっておりますので、\nお手数ですが発送手続きをお願いいたします。`
          : shippingMethod === "pickup"
          ? `集荷予定日　━━━━━━━━━━━━━━━━━━\n集荷ご希望日：${date}\nご希望時間帯：${timeslot}`
          : "発送方法の情報が不明です。";

      const shippingText2 =
        shippingMethod === "pickup"
          ? `ご連絡いただいた日時指定で、集荷依頼は出させていただいております。\n※買取についての項目を事前にご確認下さいませ。`
          : "";

      const typeText =
        buyType === "A"
          ? `買取タイプ　━━━━━━━━━━━━━━━━━━\n【TYPE-A】スピードタイプ`
          : buyType === "B"
          ? `買取タイプ　━━━━━━━━━━━━━━━━━━\n【TYPE-B】じっくりタイプ`
          : "買取タイプの情報が不明です。";
      const formattedItems =
      items.length > 0
        ? `
ご依頼頂いた商品の最新買取価格は以下となります。
━━━━━━━━━━━━━━━━━━━━━━━
${items.map((item, idx) => (
`【商品番号】${item.productNumber}
【商品名${idx + 1}】${item.productName} [個数]${item.quantity}
未開封上限￥
開封品上限￥
------------------------------------------------`
)).join('\n')}
━━━━━━━━━━━━━━━━━━━━━━━━
※アクションフィギュア・超合金系の開封済み商品の場合、
商品の状態(関節等)によっては上限の半額程度、
もしくは不可となる場合もありますので予めご承知下さい。
━━━━━━━━━━━━━━━━━━━━━━━━`
    : "";    

return `□□■━━━━━━━━━━━━━━━━━━━━━
□■　　    　買取についてのお知らせ
■━━━━━━━━━━━━━━━━━━━━━━━

${name}　様

当店をご利用頂き、誠に有難うございます。
お客様の買取依頼を受付いたしました。
${formattedItems}
今後の流れやご注意点について、下記の内容を必ずご確認ください。
◇◇◇ 必ずご確認ください ◇◇◇

◎プライズ商品は、現在“事前査定”及び“個別の査定結果連絡”を行っておりません。
　※商品点数と合計額のご連絡となります。
◎まとめて査定させていただいている商品は、個別キャンセル等は行えません。
　例）買取価格〇〇円までの商品だけキャンセルして下さい。
◎送料無料サービスのルールを含む、その他買取のルール等については、当店HPを必ずご確認ください。

◇◇◇ 買取商品の発送について※必ずご確認ください ◇◇◇

●身分証のコピーは“毎回必要”となります。
※アップロードいただいているお客様は必要ございません。

●お客様ご自身でお送りいただく場合は、本メールより4営業日(当店必着)となります。
※集荷依頼無しでお送りいただけるのは、二回目以降ご利用のお客様となります。

●集荷依頼の場合は、集荷予定日を変更された場合、無効となり再査定となります。

●当店指定業者は〝佐川急便〟となっております。
上記以外で発送された場合は、送料無料のサービス外となりますので、
予めご了承下さいませ。

${shippingText}
${typeText}
━━━━━━━━━━━━━━━━━━━━━━━━
${shippingText2}
${emailFooter}`;
    },
  },
  id_update: {
    subject: "身分証の登録・更新完了～ぱそまる～",
    body: ({ name_forid }) => `□□■━━━━━━━━━━━━━━━━━━━━━
□■　　    　身分証登録完了
■━━━━━━━━━━━━━━━━━━━━━━━
${name_forid}　様

当店をご利用いただき、誠にありがとうございます。

身分証のご連絡、誠にありがとうございます。
身分証の登録・更新が完了いたしました。
有効期限は本日より1年間となります。
有効期限は、会員ページまたは買取申込時のメールにてご確認いただけます。

それではご利用をお待ちいたしております。
${emailFooter}`,
  },
  inquiry: {
    subject: "【ぱそまる】お問い合わせありがとうございます",
    body: () => `□□■━━━━━━━━━━━━━━━━━━━━━
□■　　    　お問合せ頂いた件
■━━━━━━━━━━━━━━━━━━━━━━━

お問合せいただき、誠にありがとうございます。
ご質問について、以下の通りご案内申し上げます。

【ご案内内容】


もし、ご不明点やさらに詳しいご説明が必要な場合は、お気軽にご連絡ください。
今後とも、当店をご利用いただけますと幸いです。

それでは、どうぞよろしくお願いいたします。
${emailFooter}`,
  },
  price_info: {
    subject: "最新買取価格のお問い合わせ～ぱそまる～",
    body: () => `□□■━━━━━━━━━━━━━━━━━━━━━
□■　　    　最新買取価格の件
■━━━━━━━━━━━━━━━━━━━━━━━

当店をご利用頂き、誠に有難うございます。

お問い合わせいただいた、最新上限買取価格は以下となります。
━━━━━━━━━━━━━━━━━━━━━━━━

未開封上限￥
開封品上限￥
------------------------------------------------
━━━━━━━━━━━━━━━━━━━━━━━━
※アクションフィギュア系・超合金系の開封済み商品の場合、
商品の状態(関節等)によっては上限の半額程度、
もしくは不可となる場合もありますので予めご承知下さい。
━━━━━━━━━━━━━━━━━━━━━━━━
■注)買取金額保証ではございません。
買取保証での買取をご希望の場合は商品を選択し買取申込みをお願い致します。
※宅配買取での最新価格となります。
※もし店頭へお越しいただいた場合は、考慮させていただく場合がございますので、
メールでの問い合わせの旨を店員へお伝え下さい。
※未開封品の上限金額となります。開封されている場合減額査定となりますので予めご承知下さい。
店舗買取と宅配買取では買取価格が異なる場合がございます。
予めご承知くださいませ。

それではご検討下さいませ。
ご利用お待ちいたしております。
${emailFooter}`,
  },  
};



const folderOptions = [
  { key: "buy_request", label: "📩 買取依頼" },
  { key: "buy_approval", label: "✅ 買取承認" },
  { key: "price_info", label: "💴 最新価格" },
  { key: "id_update", label: "🪪 身分証明書更新" },
];

const MailDetail = ({
  emailId,
  currentFolder,
  isReadOnly = false,
  onReload,
  onClose,
  onSoftDelete,
  onRestore,
  storeId,
  draftId,
  setDraftId,
  setSelectedEmailId,
  setEmails,
}) => {
  const [email, setEmail] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showTemplateMenu, setShowTemplateMenu] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState({ to: "", subject: "", body: "" });
  const { showAlert, showConfirm } = useAlert();
  

  useEffect(() => {
    if (!emailId) {
      setEmail(null);
      return;
    }

    const fetch = async () => {
      let endpoint = "";

      if (currentFolder === "sent") {
        endpoint = `inventory/mail/sent/${emailId}/`;
      } else if (currentFolder === "draft") {
        endpoint = `inventory/email_drafts/${emailId}/`;
      } else {
        endpoint = `inventory/mail/received/${emailId}/`;
      }

      const res = await apiRequest(endpoint);
      setEmail(res);

      // 受信メールで未読なら既読にする
      if (currentFolder !== "sent" && currentFolder !== "draft" && !res.is_read) {
        await apiRequest(`inventory/mail/received/${emailId}/mark_read/`, "PATCH");
        onReload?.();
      }
    };

    fetch();
  }, [emailId, currentFolder, onReload]);

  if (!email) return <div className="mail-detail">メールを選択してください</div>;

  const handleDelete = async () => {
    const isDraft = currentFolder === "draft";
    const isTrash = currentFolder === "trash";

    const confirmed = showConfirm(
      isDraft
        ? "この下書きを完全に削除しますか？"
        : isTrash
        ? "このメールを完全に削除しますか？（添付も含む）"
        : "このメールをゴミ箱に移動しますか？"
    );
    if (!confirmed) return;

    let endpoint = "";
    if (isDraft) {
      endpoint = `inventory/email_drafts/${emailId}/`;  // 完全削除のみ
    } else if (isTrash) {
      endpoint = `inventory/mail/received/${emailId}/hard_delete/`;  // 完全削除
    } else {
      endpoint = `inventory/mail/received/${emailId}/delete/`;  // ゴミ箱へ移動
    }

    await apiRequest(endpoint, "DELETE");

    showAlert(
      isDraft
        ? "下書きを削除しました"
        : isTrash
        ? "完全削除しました"
        : "ゴミ箱に移動しました"
    );

    setEmail(null);
    onSoftDelete?.(emailId);
    onClose?.();
  };

  const handleRestore = async () => {
    await apiRequest(`inventory/mail/received/${emailId}/restore/`, "PATCH");
    showAlert("復元しました");
    setEmail(null);
    onRestore?.(emailId);
    onClose?.();
  };

  const handleFolderChange = async (folder) => {
    await apiRequest(`inventory/mail/received/${email.id}/`, "PATCH", { folder });
    setEmail({ ...email, folder });
    setShowDropdown(false);
    showAlert(`フォルダを「${folderOptions.find(f => f.key === folder)?.label}」に移動しました`);
    onSoftDelete?.(email.id);
    onClose?.();
  };

  const handleSendTemplate = (templateKey) => {
    const template = emailTemplates[templateKey];
    const to = isReadOnly ? email.to_address : email.from_address;
    const { name, name_forid, date, timeslot, shippingMethod, buyType, items } = extractFromBody(email.body);
    const subject = template.subject;
    const body = template.body({ name, name_forid, date, timeslot, shippingMethod, buyType, items });

    setModalData({ to, subject, body });
    setModalOpen(true);
    setShowTemplateMenu(false);
  };

  return (
    <div className="mail-detail">
      <div className="mail-detail-header">
        <div className="mail-title-row">
          <p className="mail-title">{email.subject || "(件名なし)"}</p>
          <div className="mail-actions">
            {currentFolder !== "sent" && currentFolder !== "draft" && (
              <div className="mail-template-dropdown">
                <button onClick={() => setShowTemplateMenu(!showTemplateMenu)} className="folder-button">
                  📧 メール
                </button>
                {showTemplateMenu && (
                  <ul className="folder-dropdown">
                    <li onClick={() => handleSendTemplate("buy_request")}>買取依頼受付</li>
                    <li onClick={() => handleSendTemplate("price_info")}>最新価格</li>
                    <li onClick={() => handleSendTemplate("id_update")}>身分証更新</li>
                    <li onClick={() => handleSendTemplate("inquiry")}>お問合せ</li>
                  </ul>
                )}
              </div>
            )}

            {!isReadOnly && currentFolder !== "draft" && (
              <div className="mail-folder-button-container">
                <button onClick={() => setShowDropdown(!showDropdown)} className="folder-button">
                  📂 移動
                </button>
                {showDropdown && (
                  <ul className="folder-dropdown">
                    {folderOptions.map((opt) => (
                      <li key={opt.key} onClick={() => handleFolderChange(opt.key)}>
                        {opt.label}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            )}
            {currentFolder === "draft" && (
              <button
                title="編集"
                onClick={() => {
                  setModalData({
                    to: email.to,
                    subject: email.subject,
                    body: email.body,
                  });
                  setDraftId(email.id);  // 既存の draftId を渡す
                  setModalOpen(true);    // モーダルを開く
                }}
              >
                ✏ 編集
              </button>
            )}

            {!isReadOnly && (
              currentFolder === "trash" ? (
                <>
                  <button title="復元" onClick={handleRestore}>♻️</button>
                  <button title="完全削除" onClick={handleDelete}>✖️</button>
                </>
              ) : (
                <button title="ゴミ箱へ移動" onClick={handleDelete}>🗑️</button>
              )
            )}
          </div>
        </div>

        {/* ドラフトかどうかで送受信者表示を切り替える */}
        <div className="mail-info-row">
          {currentFolder === "draft" ? (
            <>
              <span><strong>To:</strong> {email.to}</span>
              <span className="mail-date">{new Date(email.created_at).toLocaleString()}</span>
            </>
          ) : (
            <>
              <span><strong>{isReadOnly ? "To:" : "From:"}</strong> {isReadOnly ? email.to_address : email.from_address}</span>
              <span className="mail-date">{new Date(email.received_at || email.sent_at).toLocaleString()}</span>
            </>
          )}
        </div>
        <hr />
      </div>

      {/* 本文 */}
      <div className="mail-detail-scroll">
        <div className="mail-body">
          <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", padding: "10px" }}>
            {email.body}
          </pre>
        </div>

        {/* 添付（受信メールのみ） */}
        {!isReadOnly && email.attachments?.length > 0 && (
          <div className="mail-attachments">
            <h4>添付ファイル:</h4>
            <div className="attachment-grid">
              {email.attachments.map((att) => {
                const ext = att.filename.split('.').pop().toLowerCase();
                const isImage = ["jpg", "jpeg", "png", "gif", "webp"].includes(ext);
                const isPdf = ext === "pdf";
                return (
                  <div key={att.id} className="attachment-item">
                    {isImage ? (
                      <a href={att.file} target="_blank" rel="noopener noreferrer">
                        <img src={att.file} alt={att.filename} className="attachment-thumb" />
                      </a>
                    ) : isPdf ? (
                      <a href={att.file} target="_blank" rel="noopener noreferrer">
                        <iframe src={att.file} title={att.filename} className="attachment-pdf" />
                      </a>
                    ) : (
                      <a href={att.file} target="_blank" rel="noopener noreferrer">
                        {att.filename}
                      </a>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>

      {/* 📧 モーダル */}
      <EmailComposeModal
        isOpen={modalOpen}
        onClose={() => {
          setModalOpen(false)
          setDraftId(null);
          setSelectedEmailId(null)
        }}
        onRemoveDraft={(id) => {
          setEmails(prev => prev.filter(e => e.id !== id));
          setSelectedEmailId(null); // 表示が残らないように
        }}     
        to={modalData.to}
        subject={modalData.subject}
        body={modalData.body}
        storeId={storeId}
        draftId={draftId}
        setDraftId={setDraftId}
        originalMailId={emailId}
      />
    </div>
  );
};

export default MailDetail;
